export class CrawlingLogsFilters {
    level: string;
    // Inizio, formato dd/MM/yyyy HH:mm:ss
    start: string;
    // Fine, formato dd/MM/yyyy HH:mm:ss
    end: string;
}
